const comments = [
  {
    name: '影迷小陈',
    text: '春色影视真的绝了！之前在其他平台看片老是卡顿，这里秒开完全不缓冲，画质还贼清晰。已经推荐给身边所有朋友了，良心平台！',
    rating: 5,
    time: '2天前',
  },
  {
    name: '追剧达人Lucy',
    text: '追《山河纪》第三季就是在这里看的，更新速度比别家快多了。而且完全免费，不用注册就能看，这种体验真的没谁了。',
    rating: 5,
    time: '3天前',
  },
  {
    name: '电影爱好者老张',
    text: '作为一个看了几十年电影的老影迷，春色影视的片库丰富程度让我惊喜。从经典老片到最新大片应有尽有，关键是播放流畅不收费。',
    rating: 5,
    time: '5天前',
  },
  {
    name: '学生党小王',
    text: '不用下载APP，打开浏览器就能看高清，对手机存储空间太友好了。1080P画质在手机上看着也很舒服，流量消耗也不大。',
    rating: 4,
    time: '6天前',
  },
  {
    name: '剧荒拯救者',
    text: '智能推荐功能挺好用的，看了几部悬疑片之后给我推的都是类似风格的优质内容。发现了好几部之前没听过的好片子，剧荒终于有救了！',
    rating: 5,
    time: '1周前',
  },
];

export default function SectionComments() {
  return (
    <section id="comments" className="py-16 md:py-20 px-4 md:px-8 bg-background-50">
      <div className="max-w-[1000px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50 mb-3">
            观众热评
          </h2>
          <p className="text-sm text-foreground-400">听听观众们怎么说春色影视</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {comments.map((comment, i) => (
            <div
              key={i}
              className="bg-background-100/60 rounded-lg border border-background-300/20 p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-full bg-primary-500/20 flex items-center justify-center shrink-0">
                  <span className="text-xs font-bold text-primary-400">
                    {comment.name.charAt(0)}
                  </span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium text-foreground-200">{comment.name}</div>
                  <div className="text-xs text-foreground-500">{comment.time}</div>
                </div>
                <div className="flex items-center gap-0.5 shrink-0">
                  {Array.from({ length: 5 }).map((_, j) => (
                    <i
                      key={j}
                      className={`text-xs ${j < comment.rating ? 'ri-star-fill text-primary-400' : 'ri-star-line text-foreground-600'}`}
                    ></i>
                  ))}
                </div>
              </div>
              <p className="text-sm text-foreground-300 leading-relaxed">
                &ldquo;{comment.text}&rdquo;
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}